import React, { useState } from "react";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import ConfirmationBox from "../../../components/common/ConfirmationBox";
import FormAction from "../../../components/common/FormAction";
import Footer from "../../../components/common/Footer";

import { Button, Card, Checkbox, Col, Form, Radio, Row, Space } from "antd";

import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./LeaseSettings.css";

const LeaseSettingsRightBar = [];

function LeaseSettings() {
  const [value, setValue] = useState(1);
  const [checked, setChecked] = useState(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="Lease Settings" />
          <div className="lease-settings">
            <Form
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 11 }}
              colon={false}
            >
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Card title="Leases">
                    <Form.Item label="Use two column lease format">
                      <Checkbox></Checkbox>
                    </Form.Item>
                    <Form.Item label="Allow the use of Blue Moon Leases">
                      <Checkbox
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                      ></Checkbox>
                    </Form.Item>
                    <Form.Item label="Allow tenants to request notice to vacate from the online portal">
                      <Checkbox></Checkbox>
                    </Form.Item>
                    <Form.Item label="Lease Addenda Tenant Signatures">
                      <Radio.Group onChange={onChange} value={value}>
                        <Space direction="vertical">
                          <Radio value={1}>Full signatures</Radio>
                          <Radio value={2}>Initials</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                  </Card>
                </Col>
                {checked ? (
                  <Col span={24}>
                    <Card title="Blue Moon Licenses">
                      <div className="flex-container">
                        <p>
                          Add Blue Moon credentials to use Blue Moon leases in
                          Appfolio
                        </p>
                        <Button>Add Blue Moon License</Button>
                      </div>
                    </Card>
                  </Col>
                ) : null}
                <Col span={24}>
                  <Card title="Renewals">
                    <Form.Item label="Include Month-to-Month option in Prepare Renewal Offer">
                      <Checkbox></Checkbox>
                    </Form.Item>
                    <Form.Item label="Display give notice option in Renewal Notice block in online portal">
                      <Checkbox
                        
                      ></Checkbox>
                    </Form.Item>
                    <Form.Item label="Renew by Default">
                      <Checkbox
                        checked={true}
                        onChange={() => setIsConfirmationBoxOpen(true)}
                      ></Checkbox>
                    </Form.Item>
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="Move Outs">
                    <Form.Item label="Residents are required to enter a reason when moving out">
                      <Checkbox></Checkbox>
                    </Form.Item>
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title="Electronic Communications Consent Agreement">
                    <div className="flex-container">
                      <p>
                        Customize the terms that a signer agrees to before
                        accessing a document:
                      </p>
                      <div className="editor">
                        <Editor
                          editorState={editorState}
                          onEditorStateChange={setEditorState}
                        />
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col span={24}>
                  <FormAction />
                </Col>
              </Row>
            </Form>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={LeaseSettingsRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Disable Renew by Default?</h2>
          <p>
            Disabling Renew by Default will affect future renewal documents and
            all pending renewal documents with a default option chosen. Rent
            charges and dates will need to be updated manually if a renewal
            offer is not signed by a resident.
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Disable
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Close
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default LeaseSettings;
